/**
 * Auth Service (Frontend)
 *
 * Backend /api/auth/* endpoint'leri için client.
 */

import http from './http';

export const changePassword = (mevcutSifre: string, yeniSifre: string) =>
  http.patch<{ message: string }>('/api/auth/change-password', { mevcutSifre, yeniSifre });

export const forgotPassword = (email: string) =>
  http.post<{ message: string }>('/api/auth/forgot-password', { email });

export const resetPassword = (token: string, yeniSifre: string) =>
  http.post<{ message: string }>('/api/auth/reset-password', { token, yeniSifre });
